import { render, staticRenderFns } from "./FooterForm.vue?vue&type=template&id=52ea366e&scoped=true&"
import script from "./FooterForm.vue?vue&type=script&lang=js&"
export * from "./FooterForm.vue?vue&type=script&lang=js&"
import style0 from "./FooterForm.vue?vue&type=style&index=0&id=52ea366e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea366e",
  null
  
)

export default component.exports